import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { StyledButtonIcon } from './styles.js';

const ButtonIcon = forwardRef((_a, ref) => {
    var { variation, icon, disabled, onClick } = _a, props = __rest(_a, ["variation", "icon", "disabled", "onClick"]);
    return (React.createElement(StyledButtonIcon, Object.assign({ variation: variation, disabled: disabled, onClick: disabled ? undefined : onClick, ref: ref }, props), icon));
});
ButtonIcon.displayName = 'ButtonIcon';

export { ButtonIcon };
